import { h, Fragment } from 'preact'
import './index.sass'

import {
  publicProfileToDisplayName,
  publicProfileToPathname,
} from 'lib/publicProfiles'
import classNames from 'lib/classNames'

import IconRow from 'components/IconRow'
import EndUserAvatar from 'components/EndUserAvatar'

export default function DisplayNameAndAvatarRow({
  className, username, displayName, avatar, href,
  suffix, buttons, asMemberOf, isAdmin, truncateTo, ...props
}){
  if (typeof href === 'undefined')
    href = publicProfileToPathname({ username, asMemberOf })
  const truncateText = (text, maxLength) => {
    if (!maxLength || !text || text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }
  const fullDisplayName = publicProfileToDisplayName({ displayName, username })

  // Truncate if truncateTo is provided
  const truncatedName = truncateTo ? truncateText(fullDisplayName, truncateTo) : fullDisplayName

  return <IconRow {...{
    ...props,
    className: classNames('DisplayNameAndAvatarRow', { className }),
    href,
    icon:  <EndUserAvatar size="sm" publicProfile={{avatar, username}} />,
    row: <Fragment>
      <span
        className="DisplayNameAndAvatarRow-name"
        title={truncateTo && fullDisplayName.length > truncateTo ? fullDisplayName : null}
      >
        {truncatedName}
      </span>
      {isAdmin && <span className="adminBadge">Admin</span>}
      &nbsp;
      {suffix}
    </Fragment>,
    buttons,
  }}/>
}
